var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonIconMoreAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_368_62)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 10.5002C2.32843 10.5002 3 9.82867 3 9.00024C3 8.17182 2.32843 7.50024 1.5 7.50024C0.671573 7.50024 0 8.17182 0 9.00024C0 9.82867 0.671573 10.5002 1.5 10.5002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 10.5002C9.82842 10.5002 10.5 9.82867 10.5 9.00024C10.5 8.17182 9.82842 7.50024 9 7.50024C8.17157 7.50024 7.5 8.17182 7.5 9.00024C7.5 9.82867 8.17157 10.5002 9 10.5002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 10.5002C17.3284 10.5002 18 9.82867 18 9.00024C18 8.17182 17.3284 7.50024 16.5 7.50024C15.6716 7.50024 15 8.17182 15 9.00024C15 9.82867 15.6716 10.5002 16.5 10.5002Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_368_62"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconMoreAvatar);
export default __webpack_public_path__ + "static/media/common_icon_more_avatar.1c6e44ace09518926f0f62123985cecf.svg";
export { ForwardRef as ReactComponent };